export interface NotificationReceived {
  title: string | undefined;
  body: string | undefined;
  data: { [key: string]: string } | undefined;
}
